import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const CheckCircle = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, className, onClick }, ref) => (
    <svg
      ref={ref}
      className={className}
      onClick={onClick}
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="m8.5 12 2.5 2.5 4.5-5" />
    </svg>
  ),
);

export default CheckCircle;
